<template>
  <div class="our-expertise">
    <!-- Header -->
    <vue-headful
      v-if="meta"
      :title="meta.fields['Title']"
      :description="meta.fields['Description']"
      :keywords="meta.fields['Keywords']" />
    <!-- End Header -->

    <!-- Loader -->
    <vue-element-loading
      :active="!allLoaded"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- Our Expertise -->
    <v-container
      v-if="allLoaded"
      style="max-width: 1000px;">
      <section
        id="header"
        style="max-width: 1000px;">
        <h1 class="display-3 font-weight-black my-5 mx-3">
          Our Expertise
        </h1>
        <template v-if="(header)">
          <v-img
            :eager="true"
            contain
            class="ma-5"
            :src="header.fields.Attachments[0].url" />
        </template>
      </section>
      <section
        v-for="(expertise,title) in expertiseCollection"
        :id="title"
        :key="title.id"
        style="max-width: 800px;">
        <h1 class="display-1 font-weight-black pa-5">
          {{ title }}
        </h1>
        <div
          v-for="expert in expertise"
          :key="expert.id"
          class="pa-5">
          <h2>{{ expert.fields.Subtitle }}</h2>
          <div
            v-html="expert.fields.Body" />
        </div>
      </section>
    </v-container>
    <!-- End Our Expertise -->

    <!-- Case Studies -->
    <section
      v-if="allLoaded"
      id="clientele">
      <v-container
        fluid
        class="grey lighten-2 py-5">
        <v-col
          align="center"
          justify="center">
          <h2 class="display-1 font-weight-black">
            We Work With
          </h2>
          <v-row
            align="center"
            justify="center">
            <span v-for="(_caseStudyTitle) in caseStudiesTitles"
                  :key="_caseStudyTitle.id"
                  align="center"
                  justify="center"
                  class="display-1 font-weight-regular">
              <router-link
                v-if="_caseStudyTitle.fields.Order > 2"
                :to="{ name: 'work', params: { slug: _caseStudyTitle.fields.Slug } }"
                style="text-decoration: underline;">
                {{ _caseStudyTitle.fields.Name }}
              </router-link>
              <span
                v-if="(caseStudiesTitles.length !== _caseStudyTitle.fields.Order) && _caseStudyTitle.fields.Order > 2">&#44;</span>
            </span>
            <span class="display-1 font-weight-regular">&#46;</span>
          </v-row>
        </v-col>
      </v-container>
    </section>
    <!-- End Case Studies -->
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
import _ from "lodash";
import qs from "qs";

export default {
	name: "Expertise",

	components: { VueElementLoading },

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,

			isGetOurExpertiseLoading: undefined,
			isGetCaseStudiesTitlesLoading: undefined,

			header: null,
			expertiseCollection: [],
			caseStudiesTitles: []
		};
	},

	mounted: function() {
		this.getOurExpertise();
		this.getCaseStudiesTitles();
	},

	computed: {
		meta: function() {
			return this.$store.getters['meta/getMeta'](this.$route.path);
		},

		allLoaded: function() {
			if (!this.isGetOurExpertiseLoading && !this.isGetCaseStudiesTitlesLoading) {
				return true;
			}
			return false;
		}
	},

	methods: {

		getOurExpertise: function() {
			this.isGetOurExpertiseLoading = true;
			axios({
				url: this.apiUrl + this.apiBase + "/Expertise",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				}
			}).then(res => {
				let r = res.data.records;

				let groups = _.filter(r, v => !_.includes([ "Header" ], v.fields.Name));
				groups = _.groupBy(groups, function(o) {
					return o.fields.Name;
				});
				this.expertiseCollection = groups;

				/* eslint-disable no-console */
				//console.log(groups);
				/* eslint-enable no-console */
				//let self = this;
				this.header = _.find(r,function(o){return o.fields.Name === "Header";});
				// _.forEach(r, function(o) {
				// 	if (o.fields.Name === "Header") {
				// 		/* eslint-disable no-console */
				// 		//console.log(o);
				// 		/* eslint-enable no-console */
				// 		self.header = o;
				// 	} else {
				// 		self.aboutUsCollection.push(o);
				// 	}
				// });
			}).finally(() => {
				this.isGetOurExpertiseLoading = false;
			});;
		},

		getCaseStudiesTitles: function() {
			this.isGetCaseStudiesTitlesLoading = true;
			axios({
				url: this.apiUrl + this.apiBase + "/HomeWeBuildThemFor",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Order", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.caseStudiesTitles = res.data.records;
				this.caseStudiesTitles.forEach(el => el.fields.Name.trim());
			}).finally(() => {
				this.isGetCaseStudiesTitlesLoading = false;
			});
		},
	}
};
</script>
